import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { InputText } from "primereact/inputtext";

import api from "../../services/api";
import { Obrigatorio } from "../../styles/global";
import Tabela from "../../components/tabela";
import { parametrosPadrao } from "../../configs/constantes";
import debug from "../../utils/debug";
import { InputSwitch } from "primereact/inputswitch";
import { AddItem, TableSales, RemoveItem } from "./styles";
import { CalendarField } from "../../components/CalendarField";
import { Calendar } from "primereact/calendar";
import { DateMaskedField } from "../../components/DateMaskedField";

const Venda = () => {
    const classe = 'Venda';
    const tabela = 'venda';
    const endpointAPI = 'vendas/venda';
    const endpointRelatorioAPI = 'relatorios/relatorio';
    const aviso = useRef(null);
    const inicial = { id: 0, idloja: null, vendas: [] };
    const actualItemInicial = {
        idformapagamento: null,
        qtdpecas: null,
        valor: null,
        data: null,
        datacancelamento: null,
        motivocancelamento: null
    }
    const [item, setItem] = useState(inicial);
    const [actualItem, setActualItem] = useState(actualItemInicial);
    const [tituloTela, setTituloTela] = useState('');
    const [exibeTela, setExibirTela] = useState(false);
    const [listar, setListar] = useState(false);
    const [permissoesTela, setPermissoesTela] = useState(null);
    const [parametrosTela, setParametrosTela] = useState(parametrosPadrao);
    const [lojaLista, setLojaLista] = useState([]);
    const [formasPagamentoLista, setFormasPagamentoLista] = useState([]);
    const [formasPagamentoGeralLista, setFormasPagamentoGeralLista] = useState([]);
    const [loadingFormulario, setLoadingFormulario] = useState(true);
    const [desabilitarFormas, setDesabilitarFormas] = useState(true);
    const [salvandoVenda, setSalvandoVenda] = useState(false);

    const relatorioInicial = { idloja: null, idformapagamento: null, periodo_inicial: null, periodo_final: null, agrupar: false }
    const relatorioVendaPontoInicial = { idloja: null, periodo_inicial: null, periodo_final: null }
    const relatorioVendasFormaPagamentoInicial = { idloja: null, idformapagamento: null, periodo_inicial: null, periodo_final: null }
    const [relatorio, setRelatorio] = useState(relatorioInicial);
    const [relatorioVendaPonto, setRelatorioVendaPonto] = useState(relatorioVendaPontoInicial);
    const relatorioVendaColaboradorInicial = { idloja: null, periodo_inicial: null, periodo_final: null }
    const [relatorioVendaColaborador, setRelatorioVendaColaborador] = useState(relatorioVendaColaboradorInicial);
    const [relatorioVendasFormaPagamento, setRelatorioVendasFormaPagamento] = useState(relatorioVendasFormaPagamentoInicial);

    const [exibirGeracaoRelatorio, setExibirGeracaoRelatorio] = useState(false);
    const [exibirGeracaoRelatorioVendaPonto, setExibirGeracaoRelatorioVendaPonto] = useState(false);
    const [exibirGeracaoRelatorioVendaColaborador, setExibirGeracaoRelatorioVendaColaborador] = useState(false);
    const [exibirGeracaoRelatorioVendasFormaPagamento, setExibirGeracaoRelatorioVendasFormaPagamento] = useState(false);
    const [exibirRelatorioVenda, setExibirRelatorioVenda] = useState(false);
    const [exibirRelatorioVendaPonto, setExibirRelatorioVendaPonto] = useState(false);
    const [exibirRelatorioVendaColaborador, setExibirRelatorioVendaColaborador] = useState(false);
    const [exibirRelatorioVendasFormaPagamento, setExibirRelatorioVendasFormaPagamento] = useState(false);

    const relatorioVendaParamentrosInicial = { colunas: [], dados: [], totais: {} };
    const relatorioVendaPontoParamentrosInicial = { colunas: [], dados: [] };
    const relatorioVendaColaboradorParamentrosInicial = { colunas: [], dados: [], totais: {} };
    const relatorioVendasFormaPagamentoParamentrosInicial = { colunas: [], dados: [], subtotais: {}, totais: {} };
    const [relatorioVendaParamentros, setRelatorioVendaParamentros] = useState(relatorioVendaParamentrosInicial);
    const [relatorioVendaPontoParamentros, setRelatorioVendaPontoParamentros] = useState(relatorioVendaPontoParamentrosInicial);
    const [relatorioVendaColaboradorParamentros, setRelatorioVendaColaboradorParamentros] = useState(relatorioVendaColaboradorParamentrosInicial);
    const [relatorioVendasFormaPagamentoParamentros, setRelatorioVendasFormaPagamentoParamentros] = useState(relatorioVendasFormaPagamentoParamentrosInicial);

    const [exibirCancelamento, setExibirCancelmento] = useState(false);
    const cancelamentoInicial = { id: 0, motivocancelamento: null }
    const [cancelamento, setCancelamento] = useState(cancelamentoInicial)

    const qtdPecasRef = useRef(null);
    const valorRef = useRef(null);
    const periodoInicialRef = useRef(null);
    const periodoFinalRef = useRef(null);

    useEffect((e) => {
        new api().requisitar('get', `configuracao/tela/venda/permissoes`).then((resposta) => {
            setPermissoesTela(resposta);
            const parametros = {
                pesquisarTabela: true,
                artigo: 'a',
                nomeClasse: classe,
                tabela: tabela,
                caminhoBreadcrumb: [{ label: 'Vendas' }, { label: 'Registro de Venda' }],
                endpointApi: endpointAPI,
                excluirRegistro: true,
                tabelaDados: {
                    reordenar: false,
                    multiplaSelecao: true,
                    apresentarDados: true,
                    botaoAdicionar: resposta.cadastrar ?? false,
                    botaoExcluir: resposta.excluir ?? false,
                    botaoEditarRegistro: resposta.alterar ?? false,
                    botaoExcluirRegistro: resposta.excluir ?? false,
                    botaoAuditoriaRegistro: resposta.auditoria ?? false,
                    botaoVisualizarRegistro: resposta.visualizar ?? false,
                    botaoCustomizavel: resposta.relatorio ?
                        <>
                            <Button label="Gerar Relatório de Vendas" icon="pi pi-plus" className="p-button-info mt-2 mr-2" onClick={() => aoAbirGeracaoRelatorio()} />
                            <Button label="Relatório de Ponto x Última Venda" icon="pi pi-plus" className="p-button-info mt-2 mr-2" onClick={() => aoAbirGeracaoRelatorioPontoVenda()} />
                            <Button label="Relatório Vendas x Colaboradores" icon="pi pi-plus" className="p-button-info mt-2 mr-2" onClick={() => aoAbirGeracaoRelatorioVendaColaborador()} />
                            <Button label="Relatório por Forma de Pagamento" icon="pi pi-plus" className="p-button-warning mt-2 mr-2" onClick={() => aoAbirGeracaoRelatorioVendasFormaPagamento()} />
                        </>
                        : null,
                    filtroStatus: false,
                    toleranciaEdicao: true, // POSSIBILITA USUÁRIO A DELETAR E EDITAR REGISTROS DENTRO DE 5m APÓS CRIAR ITEM
                    apresentarCampos: resposta.listar, // PERMITE APRESENTAÇÃO DE CAMPOS SENSÍVEIS
                    esconderCampos: ['qtd_pecas', 'valor'], // ESCONDE CAMPOS DE USUÁRIOS SEM LISTAGEM
                    colunas: [
                        { legenda: 'Data', campo: 'data', ordenavel: true },
                        { legenda: 'Loja', campo: 'loja_nome', ordenavel: true },
                        { legenda: 'Forma Pagamento', campo: 'forma_pagamento', ordenavel: true },
                        { legenda: 'Quantidade Peças', campo: 'qtd_pecas', ordenavel: true },
                        { legenda: 'Valor', campo: 'valor', ordenavel: true },
                        { legenda: 'Situação', campo: 'situacao', ordenavel: true },
                    ]
                },
                abrirFormulario: aoAbrirFormulario,
                finalizarPesquisa: aoListar
            }
            setParametrosTela(parametros);
        }).catch((erro) => {
            throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
        });

        new api().requisitar('get', 'cadastro/loja/combo').then((resposta) => {
            setLojaLista(resposta);
        }).catch((erro) => {
            debug(erro);
        });

        new api().requisitar('get', 'vendas/formas-pagamento/combo').then((resposta) => {
            setFormasPagamentoGeralLista(resposta);
        }).catch((erro) => {
            debug(erro);
        });

    }, []);

    const carregarFormaPagamento = (idloja) => {
        setDesabilitarFormas(true);
        new api().requisitar('get', `vendas/formas-pagamento/combo/${idloja}`).then((resposta) => {
            setFormasPagamentoLista(resposta);
            setDesabilitarFormas(false);
        }).catch((erro) => {
            debug(erro);
        });
    }

    const formatarData = (data) => {
        const [parteData, parteHora] = data.split(' ');
        const [ano, mes, dia] = parteData.split('-');
        const [horas, minutos, segundos] = parteHora.split(':');
        return new Date(ano, mes - 1, dia, horas, minutos, segundos);
    };

    const formatarDataParaAPI = (data, isEnd) => {
        if (!data) return null;
        
        if (typeof data === 'string' && data.includes('/')) {
            const [dia, mes, ano] = data.split('/');
            data = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
        }
        
        if (!(data instanceof Date) || isNaN(data)) return null;
        
        const ano = data.getFullYear();
        const mes = (data.getMonth() + 1).toString().padStart(2, '0');
        const dia = data.getDate().toString().padStart(2, '0');
        
        return `${ano}-${mes}-${dia} ${(isEnd ? '23:59:59' : '00:00:00')}`;
    };

    const verificaUsuarioLoja = async () => {
        try {
            const loja = await new api().requisitar('get', 'cadastro/loja/usuario-loja');
            let _item = item;
            if (loja['id'] !== false) {
                setLojaLista([loja]);
                _item.idloja = loja['id'];
                setItem(_item);
                await carregarFormaPagamento(loja['id']);
                setDesabilitarFormas(false);
            }
        } catch (erro) {
            debug(erro);
        }
    }

    const aoAbrirFormulario = async (registro) => {
        setItem(inicial);
        setExibirTela(true);
        setLoadingFormulario(true);
        setDesabilitarFormas(true);
        if (registro.id) {
            new api().requisitar('get', `${endpointAPI}/${registro.id}`).then(async (resposta) => {
                resposta.data = formatarData(resposta.data);
                setItem(resposta);
                await carregarFormaPagamento(resposta.idloja);
                setDesabilitarFormas(false);
                setLoadingFormulario(false);
            }).catch((erro) => {
                debug(erro);
            })
            setTituloTela(`Alterar ${classe}`);
        } else {
            setTituloTela(`Cadastro de ${classe}`);
            await verificaUsuarioLoja();
            setLoadingFormulario(false);
        }
    };

    const aoListar = () => setListar(false);

    const limparTela = () => {
        setItem(inicial);
        setActualItem(actualItemInicial);
        setRelatorio(relatorioInicial);
        setRelatorioVendaPonto(relatorioVendaPontoInicial);
        setExibirTela(false);
        setExibirGeracaoRelatorio(false);
        setExibirGeracaoRelatorioVendaPonto(false);
        setExibirGeracaoRelatorioVendaColaborador(false);
        setExibirGeracaoRelatorioVendasFormaPagamento(false);
        setExibirRelatorioVenda(false);
        setExibirRelatorioVendaPonto(false);
        setExibirRelatorioVendaColaborador(false);
        setExibirRelatorioVendasFormaPagamento(false);
        setRelatorioVendaParamentros(relatorioVendaParamentrosInicial);
        setRelatorioVendaPontoParamentros(relatorioVendaPontoParamentrosInicial);
        setRelatorioVendaColaborador(relatorioVendaColaboradorParamentrosInicial);
        setRelatorioVendasFormaPagamento(relatorioVendasFormaPagamentoInicial);
        setRelatorioVendasFormaPagamentoParamentros(relatorioVendasFormaPagamentoParamentrosInicial);
        setExibirCancelmento(false);
        setCancelamento(cancelamentoInicial);
        setDesabilitarFormas(true);
        setListar(true);
    };

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
            limparTela();
        }).catch((erro) => {
            limparTela();
            debug(erro);
            aviso.current.show({ severity: 'error', summary: 'Erro', detail: (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado', life: 3000 });
        });
    };

    const cancelar = async (id) => {
        if (!cancelamento.motivocancelamento) {
            throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o motivo do cancelamento!' };
        }
        await new api().requisitar('PUT', `${endpointAPI}/cancelar/${item.id}`, cancelamento).then((resposta) => {
            aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
            limparTela();
        }).catch((erro) => {
            limparTela();
            debug(erro);
            aviso.current.show({ severity: 'error', summary: 'Erro', detail: (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado', life: 3000 });
        });
    };

    const aoAbirGeracaoRelatorio = () => {
        setExibirGeracaoRelatorio(true);
    };

    const aoAbirGeracaoRelatorioPontoVenda = () => {
        setExibirGeracaoRelatorioVendaPonto(true);
    };

    const aoAbirGeracaoRelatorioVendaColaborador = () => {
        setExibirGeracaoRelatorioVendaColaborador(true);
    };

    const aoAbirGeracaoRelatorioVendasFormaPagamento = () => {
        setExibirGeracaoRelatorioVendasFormaPagamento(true);
    };

    const aoExcluirItem = (id) => {
        confirmDialog({
            message: `Confirmar exclusão da ${classe}?`,
            header: 'Atenção',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: () => {
                excluir(id);
            },
        });
    };

    const aoCancelarItem = (id) => {
        const _cancelamento = { ...cancelamento };
        _cancelamento.id = id;
        setCancelamento(_cancelamento);
        setExibirCancelmento(true);
    };

    const aoAdicionarItem = () => {
        if (!actualItem.idformapagamento) {
            aviso.current.show({ severity: 'error', summary: 'Atenção!!', detail: 'Informe a forma de pagamento!', life: 3000 });
            return;
        }
        if (!actualItem.data) {
            aviso.current.show({ severity: 'error', summary: 'Atenção!!', detail: 'Informe a data da compra!', life: 3000 });
            return;
        }
        if (!actualItem.valor) {
            aviso.current.show({ severity: 'error', summary: 'Atenção!!', detail: 'Informe o valor pago!', life: 3000 });
            return;
        }

        setItem({
            ...item, vendas: [...(item.vendas ?? []), {
                ...actualItem,
                id: item.vendas?.length + 1
            },]
        });

        setActualItem({
            ...actualItem,
            qtdpecas: null,
            valor: null
        });

        qtdPecasRef.current.value = null;
        valorRef.current.value = null;
    }

    const aoRemoverItem = (id) => {
        const vendas = item.vendas.filter(venda => venda.id !== id);
        setItem({ ...item, vendas });
    }

    const aoSalvar = async () => {
        try {
            setSalvandoVenda(true);
            const parseItem = {
                ...item,
                vendas: item.vendas?.map(venda => ({
                    ...venda && delete venda.id && venda,
                }))
            }
            await new api().requisitar((item.id > 0) ? 'put' : 'post', (item.id > 0 ? `${endpointAPI}/${item.id ?? ''}` : endpointAPI), parseItem).then((resposta) => {
                aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
                limparTela();
            }).catch((erro) => {
                limparTela();
                throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
            });

        } catch (erro) {
            aviso.current.show({ severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000 });
        } finally {
            setSalvandoVenda(false);
        }
    };

    const aoDigitar = (e, propriedade, elemento) => {
        if (elemento === 'item') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _item = { ...item };
            _item[`${propriedade}`] = texto;
            if (propriedade === 'idloja') {
                // _item['idformapagamento'] = null;
                carregarFormaPagamento(texto);
            }
            setItem(_item);
        } else if (elemento === 'cancelamento') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _cancelmanto = { ...cancelamento };
            _cancelmanto[`${propriedade}`] = texto;
            setCancelamento(_cancelmanto);
        } else if (elemento === 'relatorio') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _relatorio = { ...relatorio };
            _relatorio[`${propriedade}`] = texto;
            setRelatorio(_relatorio);
        } else if (elemento === 'relatorio_venda_ponto') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _relatorioVendaPonto = { ...relatorioVendaPonto };
            _relatorioVendaPonto[`${propriedade}`] = texto;
            setRelatorioVendaPonto(_relatorioVendaPonto);
        } else if (elemento === 'relatorio_venda_colaborador') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _relatorioVendaColaborador = { ...relatorioVendaColaborador };
            _relatorioVendaColaborador[`${propriedade}`] = texto;
            setRelatorioVendaColaborador(_relatorioVendaColaborador);
        } else if (elemento === 'relatorio_vendas_forma_pagamento') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _relatorioVendasFormaPagamento = { ...relatorioVendasFormaPagamento };
            _relatorioVendasFormaPagamento[`${propriedade}`] = texto;
            setRelatorioVendasFormaPagamento(_relatorioVendasFormaPagamento);
        }
    };

    const estruturarRelatorio = (dados, totais) => {
        const vendasFormatada = [];
        dados.forEach((venda) => {
            const vendaFormatada = {
                data: venda.data,
                loja_nome: venda.loja_nome,
                forma_nome: venda.forma_nome,
                qtdpecas: venda.qtdpecas,
                valor: (venda.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            };
            vendasFormatada.push(vendaFormatada);
        });

        const parametrosRelatorio = {
            "colunas": [
                { "field": "data", "header": "Data" },
                { "field": "loja_nome", "header": "Loja" },
                { "field": "forma_nome", "header": "Forma de Pagamento" },
                { "field": "qtdpecas", "header": "Quantidade de Peças" },
                { "field": "valor", "header": "Valor" },
            ],
            "dados": vendasFormatada,
            "totais": {
                "qtdPecas": totais.qtdPecas,
                "valor": (totais.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
            }
        }
        setRelatorioVendaParamentros(parametrosRelatorio);
    }

    const estruturarRelatorioVendaPonto = (dados) => {
        const vendasPontosFormatados = [];

        for (var data in dados) {
            if (!dados.hasOwnProperty(data)) continue;

            const lojas = dados[data];
            for (var idloja in lojas) {
                if (!lojas.hasOwnProperty(idloja)) continue;

                const dado = lojas[idloja];
                let [ano, mes, dia] = data.split('-')
                const horarioVenda = dado.data_venda ? dado.data_venda.split(' ')[1] : '';
                const horarioSaida = dado.data_ponto ? dado.data_ponto.split(' ')[1] : '';
                const vendaPonto = {
                    data: `${dia}/${mes}/${ano}`,
                    loja_nome: dado.loja_nome,
                    colaborador_nome: dado.colaborador_nome,
                    data_ponto: horarioSaida,
                    data_venda: horarioVenda
                };
                vendasPontosFormatados.push(vendaPonto);
            }
        }

        const parametrosRelatorioVendaPonto = {
            "colunas": [
                { "field": "data", "header": "Data" },
                { "field": "loja_nome", "header": "Loja" },
                { "field": "colaborador_nome", "header": "Colaborador" },
                { "field": "data_ponto", "header": "Horário de Saída" },
                { "field": "data_venda", "header": "Horário da Última Venda" }

            ],
            "dados": vendasPontosFormatados
        }
        setRelatorioVendaPontoParamentros(parametrosRelatorioVendaPonto);
    }


    const estruturarRelatorioVendaColaborador = (dados, resumo) => {
        const vendasColaboradorFormatados = [];
        const dadosAgrupados = {};

        // Agrupar os dados por data e idloja
        dados.forEach(dado => {
            const { data, nome_colaborador, idloja, venda_loja_dia, percentual_comissao, valor_a_receber } = dado;

            // Se a data não existir no objeto, cria
            if (!dadosAgrupados[data]) {
                dadosAgrupados[data] = {};
            }

            // Se a loja não existir para a data, cria
            if (!dadosAgrupados[data][idloja]) {
                dadosAgrupados[data][idloja] = [];
            }

            // Adiciona o dado na loja específica para aquele dia
            dadosAgrupados[data][idloja].push({
                colaborador_nome: nome_colaborador,
                venda_loja_dia,
                percentual_comissao,
                valor_a_receber
            });
        });

        // Formatando os dados agrupados
        for (var data in dadosAgrupados) {
            if (!dadosAgrupados.hasOwnProperty(data)) continue;

            const lojas = dadosAgrupados[data];
            for (var idloja in lojas) {
                if (!lojas.hasOwnProperty(idloja)) continue;

                const colaboradores = lojas[idloja];
                for (let colaborador of colaboradores) {
                    let [dia, mes] = data.split('/');

                    const vendaPonto = {
                        data: `${dia}/${mes}`,
                        nome_colaborador: colaborador.colaborador_nome,
                        venda_loja_dia: colaborador.venda_loja_dia.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
                        percentual_comissao: colaborador.percentual_comissao,
                        valor_a_receber: colaborador.valor_a_receber.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
                    };
                    vendasColaboradorFormatados.push(vendaPonto);
                }
            }
        }

        const parametrosRelatorioVendaColaborador = {
            "colunas": [
                { "field": "data", "header": "Data" },
                { "field": "nome_colaborador", "header": "Nome do Funcionário" },
                { "field": "percentual_comissao", "header": "% Comissão" },
                { "field": "venda_loja_dia", "header": "Venda Loja" },
                { "field": "valor_a_receber", "header": "Valor a Receber" },
            ],
            "dados": vendasColaboradorFormatados,
            "totais": {
                "total_vendas": (resumo.total_vendas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
                "total_comissao": (resumo.total_comissao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
            }
        };

        setRelatorioVendaColaboradorParamentros(parametrosRelatorioVendaColaborador);
    };

    const estruturarRelatorioVendasFormaPagamento = (dados, subtotais, totais) => {
        const vendasFormaPagamentoFormatadas = [];
        
        for (const formaPagamento in dados) {
            vendasFormaPagamentoFormatadas.push({
                tipo: 'header',
                forma_pagamento: formaPagamento,
                data: '',
                loja_nome: '',
                qtdpecas: '',
                valor: ''
            });
            
            dados[formaPagamento].forEach((venda) => {
                vendasFormaPagamentoFormatadas.push({
                    tipo: 'item',
                    forma_pagamento: '',
                    data: venda.data,
                    loja_nome: venda.loja_nome,
                    qtdpecas: venda.qtdpecas,
                    valor: (venda.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                });
            });
            
            vendasFormaPagamentoFormatadas.push({
                tipo: 'subtotal',
                forma_pagamento: `Subtotal ${formaPagamento}:`,
                data: '',
                loja_nome: '',
                qtdpecas: subtotais[formaPagamento].qtdPecas,
                valor: (subtotais[formaPagamento].valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            });
        }

        const parametrosRelatorioVendasFormaPagamento = {
            "colunas": [
                { "field": "forma_pagamento", "header": "Forma de Pagamento" },
                { "field": "data", "header": "Data" },
                { "field": "loja_nome", "header": "Loja" },
                { "field": "qtdpecas", "header": "Quantidade de Peças" },
                { "field": "valor", "header": "Valor" },
            ],
            "dados": vendasFormaPagamentoFormatadas,
            "subtotais": subtotais,
            "totais": {
                "qtdPecas": totais.qtdPecas,
                "valor": (totais.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
            }
        }
        setRelatorioVendasFormaPagamentoParamentros(parametrosRelatorioVendasFormaPagamento);
    };

    const aoGerarRelatorio = async () => {
        try {
            const periodoInicial = relatorio.periodo_inicial;
            const periodoFinal = relatorio.periodo_final;
            
            if (periodoInicial && periodoFinal) {
                let dataInicial = periodoInicial;
                let dataFinal = periodoFinal;
                
                if (typeof periodoInicial === 'string' && periodoInicial.includes('/')) {
                    const [dia, mes, ano] = periodoInicial.split('/');
                    dataInicial = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
                }
                
                if (typeof periodoFinal === 'string' && periodoFinal.includes('/')) {
                    const [dia, mes, ano] = periodoFinal.split('/');
                    dataFinal = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
                }
                
                if (dataInicial > dataFinal) {
                    throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe um período válido!' };
                }
            }

            const dadosRelatorio = {
                ...relatorio,
                periodo_inicial: formatarDataParaAPI(relatorio.periodo_inicial),
                periodo_final: formatarDataParaAPI(relatorio.periodo_final, true)
            };

            await new api().requisitar('post', `${endpointRelatorioAPI}/gerar-relatorio/venda`, dadosRelatorio)
                .then((resposta) => {
                    // Exibir mensagem, caso tenha vendas gera relatório
                    setExibirGeracaoRelatorio(false);
                    if (resposta.dados && resposta.dados.length > 0) {
                        setExibirRelatorioVenda(true);
                        estruturarRelatorio(resposta.dados, resposta.totais);
                        aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
                    } else {
                        limparTela();
                        aviso.current.show({ severity: 'warn', summary: 'Nenhuma Venda Encontrada', detail: 'Nenhuma venda encontrada para os filtros aplicados', life: 4000 });
                    }
                })
                .catch((erro) => {
                    // Lidar com erros
                    throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
                });

        } catch (erro) {
            aviso.current.show({ severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000 });
        }
    }

    const aoGerarRelatorioVendasFormaPagamento = async () => {
        try {
            const periodoInicial = relatorioVendasFormaPagamento.periodo_inicial;
            const periodoFinal = relatorioVendasFormaPagamento.periodo_final;
            
            if (periodoInicial && periodoFinal) {
                let dataInicial = periodoInicial;
                let dataFinal = periodoFinal;
                
                if (typeof periodoInicial === 'string' && periodoInicial.includes('/')) {
                    const [dia, mes, ano] = periodoInicial.split('/');
                    dataInicial = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
                }
                
                if (typeof periodoFinal === 'string' && periodoFinal.includes('/')) {
                    const [dia, mes, ano] = periodoFinal.split('/');
                    dataFinal = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
                }
                
                if (dataInicial > dataFinal) {
                    throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe um período válido!' };
                }
            }

            const dadosRelatorio = {
                ...relatorioVendasFormaPagamento,
                periodo_inicial: formatarDataParaAPI(relatorioVendasFormaPagamento.periodo_inicial),
                periodo_final: formatarDataParaAPI(relatorioVendasFormaPagamento.periodo_final, true)
            };

            await new api().requisitar('post', `${endpointRelatorioAPI}/gerar-relatorio/vendas-por-forma-pagamento`, dadosRelatorio)
                .then((resposta) => {
                    setExibirGeracaoRelatorioVendasFormaPagamento(false);
                    if (resposta.dados && Object.keys(resposta.dados).length > 0) {
                        setExibirRelatorioVendasFormaPagamento(true);
                        estruturarRelatorioVendasFormaPagamento(resposta.dados, resposta.subtotais, resposta.totais);
                        aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
                    } else {
                        limparTela();
                        aviso.current.show({ severity: 'warn', summary: 'Nenhuma Venda Encontrada', detail: 'Nenhuma venda encontrada para os filtros aplicados', life: 4000 });
                    }
                })
                .catch((erro) => {
                    throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
                });

        } catch (erro) {
            aviso.current.show({ severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000 });
        }
    }

    const aoGerarRelatorioVendaPonto = async () => {
        try {
            if ((relatorioVendaPonto.periodo_final && relatorioVendaPonto.periodo_inicial) && (relatorioVendaPonto.periodo_inicial > relatorioVendaPonto.periodo_final)) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe um período válido!' };
            }

            await new api().requisitar('post', `${endpointRelatorioAPI}/gerar-relatorio/ponto-ultima-venda`, relatorioVendaPonto)
                .then((resposta) => {
                    // Exibir mensagem, caso tenha vendas gera relatório
                    setExibirGeracaoRelatorioVendaPonto(false);
                    if (resposta.dados && (Array.isArray(resposta.dados) && resposta.dados.length > 0) || !Array.isArray(resposta.dados)) {
                        setExibirRelatorioVendaPonto(true);
                        estruturarRelatorioVendaPonto(resposta.dados);
                        aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
                    } else {
                        limparTela();
                        aviso.current.show({ severity: 'warn', summary: 'Nenhum Dado Encontrado', detail: 'Nenhum dado encontrada para os filtros aplicados', life: 4000 });
                    }
                })
                .catch((erro) => {
                    // Lidar com erros
                    throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
                });

        } catch (erro) {
            aviso.current.show({ severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000 });
        }
    }
    const aoGerarRelatorioVendaColaborador = async () => {
        try {
            if ((relatorioVendaColaborador.periodo_final && relatorioVendaColaborador.periodo_inicial) && (relatorioVendaColaborador.periodo_inicial > relatorioVendaColaborador.periodo_final)) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe um período válido!' };
            }

            await new api().requisitar('post', `${endpointRelatorioAPI}/gerar-relatorio/comissao`, relatorioVendaColaborador)
                .then((resposta) => {
                    // Exibir mensagem, caso tenha vendas gera relatório
                    setExibirGeracaoRelatorioVendaPonto(false);
                    if (resposta.dados && (Array.isArray(resposta.dados) && resposta.dados.length > 0) || !Array.isArray(resposta.dados)) {
                        setExibirRelatorioVendaColaborador(true);
                        estruturarRelatorioVendaColaborador(resposta.dados, resposta.resumo);
                        aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });

                    } else {
                        limparTela();
                        aviso.current.show({ severity: 'warn', summary: 'Nenhum Dado Encontrado', detail: 'Nenhum dado encontrada para os filtros aplicados', life: 4000 });
                    }
                })
                .catch((erro) => {
                    // Lidar com erros
                    throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
                });

        } catch (erro) {
            aviso.current.show({ severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000 });
        }
    }

    const exportarPdf = (tipo) => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default('l', 'mm', 'a4');

                // Adiciona o título
                doc.setFontSize(18);
                const titulo = tipo === 'venda' ? 'Vendas' :
                              tipo === 'venda-colaborador' ? 'Venda X Colaborador' :
                              tipo === 'vendas-forma-pagamento' ? 'Vendas por Forma de Pagamento' :
                              'Ponto X Última Venda';
                doc.text(`Relatório de ${titulo}`, 14, 20);

                // Define header e body
                const colunas = tipo === 'venda' ?
                    relatorioVendaParamentros.colunas.map((col) => ({ title: col.header, dataKey: col.field }))
                    : tipo === 'venda-colaborador' ? relatorioVendaColaboradorParamentros.colunas.map((col) => ({ title: col.header, dataKey: col.field }))
                    : tipo === 'vendas-forma-pagamento' ? relatorioVendasFormaPagamentoParamentros.colunas.map((col) => ({ title: col.header, dataKey: col.field }))
                    : relatorioVendaPontoParamentros.colunas.map((col) => ({ title: col.header, dataKey: col.field }));
                const data = tipo === 'venda' ? relatorioVendaParamentros.dados
                    : tipo === 'venda-colaborador' ? relatorioVendaColaboradorParamentros.dados
                    : tipo === 'vendas-forma-pagamento' ? relatorioVendasFormaPagamentoParamentros.dados
                    : relatorioVendaPontoParamentros.dados;

                const footerRow = tipo === 'venda' ? [
                    {
                        "data": "",
                        "loja_nome": "",
                        "forma_nome": "Totais: ",
                        "qtdpecas": relatorioVendaParamentros.totais.qtdPecas,
                        "valor": relatorioVendaParamentros.totais.valor
                    }
                ] : tipo === 'venda-colaborador' ? [
                    {
                        "data": "",
                        "nome_colaborador": "",
                        "percentual_comissao": "Totais: ",
                        "venda_loja_dia": relatorioVendaColaboradorParamentros.totais.total_vendas,
                        "valor_a_receber": relatorioVendaColaboradorParamentros.totais.total_comissao

                    }
                ] : [];

                const body = [...data, ...footerRow];

                doc.autoTable(colunas, body, {
                    margin: { top: 25 },
                });

                const nomeRelatorio = tipo === 'venda' ? `Relatório de Vendas.pdf`
                    : tipo === 'venda-colaborador' ? `Relatório Venda X Colaborador.pdf`
                    : tipo === 'vendas-forma-pagamento' ? `Relatório Vendas por Forma de Pagamento.pdf`
                    : `Relatório Ponto X Última Venda.pdf`;
                doc.save(nomeRelatorio);
            });
        });
    };

    const botoesAcaoTela = () => {
        return (<React.Fragment>
            <Button label="Voltar" icon="pi pi-times" className="p-button-text" onClick={(e) => setExibirTela(false)} />
            {(item.id > 0 && item.status > 0 && permissoesTela.desabilitar && !item.datacancelamento) && <Button label="Cancelar Venda" icon="pi pi-times" className="p-button-text" onClick={(e) => aoCancelarItem(item.id)} />}
            {item.id > 0 && item.status > 0 && permissoesTela.exluir && <Button label="Excluir" icon="pi pi-times" className="p-button-text" onClick={(e) => aoExcluirItem(item.id)} />}
            {((item.id > 0 && permissoesTela.alterar && !item.datacancelamento) || (item.id === 0 && permissoesTela.cadastrar)) &&
                <Button
                    label={salvandoVenda ? "Salvando..." : "Salvar"}
                    icon={salvandoVenda ? "pi pi-spin pi-spinner" : "pi pi-check"}
                    className="p-button-text"
                    onClick={aoSalvar}
                    disabled={salvandoVenda}
                />
            }
        </React.Fragment>);
    };

    const botoesAcaoCancelamento = () => {
        return (<React.Fragment>
            <Button label="Voltar" icon="pi pi-times" className="p-button-text" onClick={limparTela} />
            <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={cancelar} />
        </React.Fragment>);
    }

    const botoesAcaoTelaRelatorio = () => {
        return (<React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={limparTela} />
            <Button label="Gerar" icon="pi pi-check" className="p-button-text" onClick={aoGerarRelatorio} />
        </React.Fragment>);
    };

    const botoesAcaoTelaRelatorioVendaPonto = () => {
        return (<React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={limparTela} />
            <Button label="Gerar" icon="pi pi-check" className="p-button-text" onClick={aoGerarRelatorioVendaPonto} />
        </React.Fragment>);
    }
    const botoesAcaoTelaRelatorioVendaColaborador = () => {
        return (<React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={limparTela} />
            <Button label="Gerar" icon="pi pi-check" className="p-button-text" onClick={aoGerarRelatorioVendaColaborador} />
        </React.Fragment>);
    }

    const botoesAcaoTelaRelatorioVendasFormaPagamento = () => {
        return (<React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={limparTela} />
            <Button label="Gerar" icon="pi pi-check" className="p-button-text" onClick={aoGerarRelatorioVendasFormaPagamento} />
        </React.Fragment>);
    }

    const botoesRelatorio = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button label="Salvar em PDF" type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={() => exportarPdf('venda')} data-pr-tooltip="PDF" />
        </div>
    );

    const botoesRelatorioVendaPonto = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button label="Salvar em PDF" type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={() => exportarPdf('venda-ponto')} data-pr-tooltip="PDF" />
        </div>
    );

    const botoesRelatorioVendaColaborador = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button label="Salvar em PDF" type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={() => exportarPdf('venda-colaborador')} data-pr-tooltip="PDF" />
        </div>
    );

    const botoesRelatorioVendasFormaPagamento = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button label="Salvar em PDF" type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={() => exportarPdf('vendas-forma-pagamento')} data-pr-tooltip="PDF" />
        </div>
    );

    const totais = (
        <ColumnGroup>
            <Row>
                <Column footer="Totais:" colSpan={3} footerStyle={{ textAlign: 'right' }} />
                <Column footer={relatorioVendaParamentros.totais.qtdPecas} />
                <Column footer={relatorioVendaParamentros.totais.valor} />
            </Row>
        </ColumnGroup>
    );

    const totaisVendaColaborador = (
        <ColumnGroup>
            <Row>
                <Column footer="Totais:" colSpan={3} footerStyle={{ textAlign: 'right' }} />
                <Column footer={relatorioVendaColaboradorParamentros.totais.total_vendas} />
                <Column footer={relatorioVendaColaboradorParamentros.totais.total_comissao} />
            </Row>
        </ColumnGroup>
    );

    useEffect(() => {
        window.addEventListener('load', () => {
            const valor = document.getElementById('valor');
            if (valor) {
                valor.setAttribute('autocomplete', 'off');
            }
        })

    }, []);

    useEffect(() => {
        onkeydown = (e) => {
            if (e.key === 'Enter' && exibeTela && actualItem.data && actualItem.idformapagamento && actualItem.valor) {
                aoAdicionarItem();
            }
        }
    }, [actualItem, aoAdicionarItem, exibeTela]);

    return (
        <Tabela parametros={parametrosTela} listar={listar}>
            <Toast ref={aviso}></Toast>
            <Dialog className='fluid' header={tituloTela} style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoTela} modal={true} visible={exibeTela} onHide={(e) => setExibirTela(false)}>
                {loadingFormulario ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                    </div>
                ) : (
                    <>
                        <div className="grid formgrid">
                            <div className="flex col-12 p-0 mt-3">
                                <div className="field col-12">
                                    <label htmlFor="idpais">Loja<Obrigatorio>*</Obrigatorio> </label><br />
                                    <Dropdown filter filterInputAutoFocus className="w-full" autoComplete="none" id="idloja" value={item.idloja} options={lojaLista} onChange={(e) => aoDigitar(e, 'idloja', 'item')} optionLabel="valor"
                                        optionValue="id" required disabled={item.idloja > 0} />
                                </div>
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="flex col-12 p-0 mt-3">
                                <div className="field col-6">
                                    <label htmlFor="idpais">Data de venda<Obrigatorio>*</Obrigatorio> </label><br />
                                    <CalendarField
                                        id="time24"
                                        value={actualItem.data}
                                        onChange={(e) => {
                                            setActualItem({ ...actualItem, data: e.value });
                                        }}
                                        className="w-full"
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999 99:99"
                                        hourFormat="24"
                                        showTime
                                        autoComplete="off"
                                        inputRef={ref => {
                                            if (ref) {
                                                ref.setAttribute('autocomplete', 'off');
                                            }
                                        }}
                                    />
                                </div>
                                <div className="field col-6">
                                    <label htmlFor="idpais">Forma de Pagamento<Obrigatorio>*</Obrigatorio> </label><br />
                                    <Dropdown filter filterInputAutoFocus className="w-full" autoComplete="none" id="idformapagamento" value={item.idformapagamento ?? actualItem.idformapagamento} options={formasPagamentoLista} onChange={(e) => setActualItem({ ...actualItem, idformapagamento: e.target.value })} optionLabel="valor"
                                        optionValue="id" required disabled={desabilitarFormas} />
                                </div>
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="flex col-12 p-0 mt-3">
                                <div className="field col-6">
                                    <label htmlFor="valor">Quantidade de Peças<Obrigatorio>*</Obrigatorio></label><br />
                                    <InputNumber
                                        inputId="qtdpecas"
                                        value={item.qtdpecas ?? actualItem.qtdpecas}
                                        onChange={(e) => setActualItem({ ...actualItem, qtdpecas: e.value })}
                                        className="w-full"
                                        inputRef={qtdPecasRef}
                                        autoComplete="off"
                                        ref={e => {
                                            const input = e?.getInput();
                                            if (input) input.setAttribute('autocomplete', 'off');
                                        }}
                                    />
                                </div>
                                <div className="field col-6">
                                    <label htmlFor="valor">Valor<Obrigatorio>*</Obrigatorio></label><br />
                                    <InputNumber
                                        inputId="valor"
                                        value={item.valor ?? actualItem.valor}
                                        onChange={(e) => {
                                            setActualItem({ ...actualItem, valor: String(e.value) })
                                            aoDigitar(e, 'valor', 'item');
                                        }}
                                        mode="currency"
                                        currency="BRL"
                                        locale="pt-BR"
                                        className="w-full"
                                        inputRef={valorRef}
                                        autoComplete="off"
                                        ref={e => {
                                            const input = e?.getInput();
                                            if (input) input.setAttribute('autocomplete', 'off');
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="field col-12">
                                <AddItem>
                                    <i className="pi pi-plus"></i>
                                    <p htmlFor="idpais" onClick={aoAdicionarItem}>Adicionar Item</p>
                                </AddItem>
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="field col-12">
                                <TableSales value={item.vendas} emptyMessage="Nenhuma venda encontrada">
                                    <Column field="qtdpecas" header="Quantidade de peças" />
                                    <Column field="idformapagamento" header="Forma de pagamento" body={(row) => formasPagamentoLista.find((i) => i.id === row.idformapagamento).valor} />
                                    <Column field="valor" header="Valor (R$)" body={(row) => (row.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} />
                                    <Column field="data" header="Data" body={(row) => {
                                        const date = new Date(row.data);
                                        const formatNumber = (num) => String(num).padStart(2, '0');
                                        const formattedDate = [
                                            formatNumber(date.getDate()),
                                            formatNumber(date.getMonth() + 1),
                                            date.getFullYear(),
                                        ].join('/');
                                        const formattedTime = [
                                            formatNumber(date.getHours()),
                                            formatNumber(date.getMinutes()),
                                        ].join(':');
                                        return `${formattedDate} ${formattedTime}`;
                                    }} />
                                    <Column header="Ação" body={(row) => <RemoveItem onClick={() => aoRemoverItem(row.id)}><i className="pi pi-trash"></i> Remover</RemoveItem>} />
                                </TableSales>
                            </div>
                        </div>
                        {
                            item.datacancelamento ?
                                <div className="grid formgrid">
                                    <div className="field col-12 mt-3">
                                        <label htmlFor="descricao">Descrição do Cancelamento</label><br />
                                        <InputText className="w-full" autoComplete="none" id="descricao" maxLength={200} value={item.motivocancelamento} onChange={(e) => aoDigitar(e, 'motivocancelamento', 'item')} required disabled={true} />
                                    </div>
                                </div>
                                : null
                        }
                    </>
                )}
            </Dialog>

            <Dialog className='fluid' header='Cancelamento de Venda' style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoCancelamento} modal={true} visible={exibirCancelamento} onHide={limparTela}>
                <div className="grid formgrid">
                    <div className="field col-12 mt-3">
                        <label htmlFor="descricao">Descrição do Cancelamento</label><br />
                        <InputText className="w-full" autoComplete="none" id="descricao" maxLength={200} value={cancelamento.motivocancelamento} onChange={(e) => aoDigitar(e, 'motivocancelamento', 'cancelamento')} required />
                    </div>
                </div>
            </Dialog>

            <Dialog className='fluid' header='Geração de Relatório' style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoTelaRelatorio} modal={true} visible={exibirGeracaoRelatorio} onHide={limparTela}>
                <div className="grid formgrid">
                    <div className="field col-12 mt-3">
                        <label htmlFor="idagrupar">Agrupar por Forma de Pagamento</label>
                        <br />
                        <InputSwitch id="idagrupar" checked={relatorio.agrupar} onChange={(e) => aoDigitar(e, 'agrupar', 'relatorio')} />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idloja">Loja</label><br />
                        <Dropdown filter className="w-full" autoComplete="none" id="idloja" value={relatorio.idloja} options={lojaLista} onChange={(e) => aoDigitar(e, 'idloja', 'relatorio')} optionLabel="valor"
                            optionValue="id" required />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idloja">Formas de Pagamento</label><br />
                        <Dropdown filter className="w-full" autoComplete="none" id="idloja" value={relatorio.idformapagamento} options={formasPagamentoGeralLista} onChange={(e) => aoDigitar(e, 'idformapagamento', 'relatorio')} optionLabel="valor"
                            optionValue="id" required />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="periodo_inicial">Período Inicial</label><br />
                        <DateMaskedField
                            ref={periodoInicialRef}
                            value={relatorio.periodo_inicial}
                            onChange={(value) => aoDigitar({ value }, 'periodo_inicial', 'relatorio')}
                            nextFieldRef={periodoFinalRef}
                            placeholder="dd/mm/aaaa"
                            className="w-full"
                        />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="periodo_final">Período Final</label><br />
                        <DateMaskedField
                            ref={periodoFinalRef}
                            value={relatorio.periodo_final}
                            onChange={(value) => aoDigitar({ value }, 'periodo_final', 'relatorio')}
                            placeholder="dd/mm/aaaa"
                            className="w-full"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog className='fluid' header='Geração de Relatório de Ponto X Última Venda' style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoTelaRelatorioVendaPonto} modal={true} visible={exibirGeracaoRelatorioVendaPonto} onHide={limparTela}>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idloja">Loja</label><br />
                        <Dropdown filter className="w-full" autoComplete="none" id="idloja" value={relatorioVendaPonto.idloja} options={lojaLista} onChange={(e) => aoDigitar(e, 'idloja', 'relatorio_venda_ponto')} optionLabel="valor"
                            optionValue="id" required />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idpais">Período Inicial</label><br />
                        <CalendarField
                            value={relatorioVendaPonto.periodo_inicial}
                            onChange={(e) => aoDigitar(e, 'periodo_inicial', 'relatorio_venda_ponto')}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                        />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idpais">Período Final</label><br />
                        <CalendarField
                            value={relatorioVendaPonto.periodo_final}
                            onChange={(e) => aoDigitar(e, 'periodo_final', 'relatorio_venda_ponto')}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                        />
                    </div>
                </div>
            </Dialog>
            <Dialog className='fluid' header='Geração de Relatório de Venda X Colaborador' style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoTelaRelatorioVendaColaborador} visible={exibirGeracaoRelatorioVendaColaborador} onHide={limparTela}>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idloja">Loja</label><br />
                        <Dropdown filter className="w-full" autoComplete="none" id="idloja" value={relatorioVendaColaborador.idloja} options={lojaLista} onChange={(e) => aoDigitar(e, 'idloja', 'relatorio_venda_colaborador')} optionLabel="valor"
                            optionValue="id" required />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idpais">Período Inicial <Obrigatorio>*</Obrigatorio></label><br />
                        <CalendarField
                            value={relatorioVendaColaborador.periodo_inicial}
                            onChange={(e) => aoDigitar(e, 'periodo_inicial', 'relatorio_venda_colaborador')}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                        />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idpais">Período Final <Obrigatorio>*</Obrigatorio></label><br />
                        <CalendarField
                            value={relatorioVendaColaborador.periodo_final}
                            onChange={(e) => aoDigitar(e, 'periodo_final', 'relatorio_venda_colaborador')}
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                className='fluid'
                header={`Relatório de Vendas`}
                style={{ maxWidth: '95%', width: '95%' }}
                contentStyle={{ height: '100%', width: '100%' }}
                modal={true}
                visible={exibirRelatorioVenda}
                onHide={limparTela}
                closeOnEscape={false}
                maximizable
            >
                <Tooltip target=".export-buttons>button" position="bottom" />
                <DataTable value={relatorioVendaParamentros.dados} header={botoesRelatorio} tableStyle={{ width: '100%' }} footerColumnGroup={totais} showGridlines scrollable scrollHeight="flex">
                    {relatorioVendaParamentros.colunas.map((col, index) => {
                        return (
                            <Column
                                key={index}
                                field={col.field}
                                header={col.header}
                            />
                        );
                    })}
                </DataTable>
            </Dialog>

            <Dialog
                className='fluid'
                header={`Relatório de Ponto X Última Venda`}
                style={{ maxWidth: '95%', width: '95%' }}
                contentStyle={{ height: '100%', width: '100%' }}
                modal={true}
                visible={exibirRelatorioVendaPonto}
                onHide={limparTela}
                closeOnEscape={false}
                maximizable
            >
                <Tooltip target=".export-buttons>button" position="bottom" />
                <DataTable value={relatorioVendaPontoParamentros.dados} header={botoesRelatorioVendaPonto} tableStyle={{ width: '100%' }} showGridlines scrollable scrollHeight="flex">
                    {relatorioVendaPontoParamentros.colunas.map((col, index) => {
                        return (
                            <Column
                                key={index}
                                field={col.field}
                                header={col.header}
                            />
                        );
                    })}
                </DataTable>
            </Dialog>
            <Dialog
                className='fluid'
                header={`Relatório de Venda X Colaborador`}
                style={{ maxWidth: '95%', width: '95%' }}
                contentStyle={{ height: '100%', width: '100%' }}
                modal={true}
                visible={exibirRelatorioVendaColaborador}
                onHide={limparTela}
                closeOnEscape={false}
                maximizable
            >
                <Tooltip target=".export-buttons>button" position="bottom" />
                <DataTable value={relatorioVendaColaboradorParamentros.dados} header={botoesRelatorioVendaColaborador} footerColumnGroup={totaisVendaColaborador} tableStyle={{ width: '100%' }} showGridlines scrollable scrollHeight="flex">
                    {relatorioVendaColaboradorParamentros.colunas.map((col, index) => {
                        return (
                            <Column
                                key={index}
                                field={col.field}
                                header={col.header}
                            />
                        );
                    })}
                </DataTable>
            </Dialog>

            <Dialog className='fluid' header='Geração de Relatório por Forma de Pagamento' style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoTelaRelatorioVendasFormaPagamento} modal={true} visible={exibirGeracaoRelatorioVendasFormaPagamento} onHide={limparTela}>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idloja">Loja</label><br />
                        <Dropdown filter className="w-full" autoComplete="none" id="idloja" value={relatorioVendasFormaPagamento.idloja} options={lojaLista} onChange={(e) => aoDigitar(e, 'idloja', 'relatorio_vendas_forma_pagamento')} optionLabel="valor"
                            optionValue="id" />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="idformapagamento">Formas de Pagamento</label><br />
                        <Dropdown filter className="w-full" autoComplete="none" id="idformapagamento" value={relatorioVendasFormaPagamento.idformapagamento} options={formasPagamentoGeralLista} onChange={(e) => aoDigitar(e, 'idformapagamento', 'relatorio_vendas_forma_pagamento')} optionLabel="valor"
                            optionValue="id" />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="periodo_inicial">Período Inicial</label><br />
                        <DateMaskedField
                            value={relatorioVendasFormaPagamento.periodo_inicial}
                            onChange={(value) => aoDigitar({ value }, 'periodo_inicial', 'relatorio_vendas_forma_pagamento')}
                            placeholder="dd/mm/aaaa"
                            className="w-full"
                        />
                    </div>
                </div>
                <div className="grid formgrid">
                    <div className="field col-12">
                        <label htmlFor="periodo_final">Período Final</label><br />
                        <DateMaskedField
                            value={relatorioVendasFormaPagamento.periodo_final}
                            onChange={(value) => aoDigitar({ value }, 'periodo_final', 'relatorio_vendas_forma_pagamento')}
                            placeholder="dd/mm/aaaa"
                            className="w-full"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                className='fluid'
                header={`Relatório de Vendas por Forma de Pagamento`}
                style={{ maxWidth: '95%', width: '95%' }}
                contentStyle={{ height: '100%', width: '100%' }}
                modal={true}
                visible={exibirRelatorioVendasFormaPagamento}
                onHide={limparTela}
                closeOnEscape={false}
                maximizable
            >
                <Tooltip target=".export-buttons>button" position="bottom" />
                <DataTable
                    value={relatorioVendasFormaPagamentoParamentros.dados}
                    header={botoesRelatorioVendasFormaPagamento}
                    tableStyle={{ width: '100%' }}
                    showGridlines
                    scrollable
                    scrollHeight="flex"
                    rowClassName={(data) => {
                        if (data.tipo === 'header') return 'p-highlight font-bold';
                        if (data.tipo === 'subtotal') return 'p-highlight-blue font-bold';
                        return '';
                    }}
                >
                    {relatorioVendasFormaPagamentoParamentros.colunas?.map((col, index) => {
                        return (
                            <Column
                                key={index}
                                field={col.field}
                                header={col.header}
                            />
                        );
                    })}
                </DataTable>
                <div className="mt-3 p-3" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                    <div className="flex justify-content-between align-items-center">
                        <strong>TOTAL GERAL:</strong>
                        <div className="flex gap-4">
                            <span><strong>Quantidade Total: {relatorioVendasFormaPagamentoParamentros.totais?.qtdPecas}</strong></span>
                            <span><strong>Valor Total: {relatorioVendasFormaPagamentoParamentros.totais?.valor}</strong></span>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Tabela>
    );
}

export default Venda;
